import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { DeforestationHistoricalChart } from '@/components/Charts/DeforestationHistorical';
import { GraphFact } from '@/components/Charts/types';

import { NoPlotData } from '../NoPlotData';

export const DeforestationGraphTile = ({
  graphData,
  benchmarkData,
}: {
  graphData: GraphFact[] | null | undefined;
  benchmarkData: GraphFact[] | null | undefined;
}) => {
  const { t } = useTranslation();

  const noChartData = !graphData?.length;

  if (noChartData) {
    return <NoPlotData />;
  }

  const chartData = [...graphData, ...(benchmarkData ?? [])];

  return (
    <Stack
      spacing={6}
      data-testid='deforestation-graph-tile'
      className='items-center justify-center px-1 py-6 lg:items-start lg:p-6 lg:pl-1'
    >
      <ChartHeading
        heading={t('shared.ncaDetail.details.deforestation.labels.historicalGraphHeadline')}
        popover={{
          title: t('shared.ncaDetail.details.deforestation.explainers.deforestation.title'),
          body: t('shared.ncaDetail.details.deforestation.explainers.deforestation.body'),
        }}
        className='w-full px-6 sm:px-0'
      />
      <DeforestationHistoricalChart data={chartData} />
    </Stack>
  );
};
